import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  Button,
  TextField,
  Stack
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Cart, {generateCartItemsFrom} from "./Cart"


// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {
  const [card, setCard] = useState(0);
  const [circle, setCircle] = useState(0);
  // const [searchString, setSearchString] = useState("");
  let [productData, setProductData] = useState([]);
  const [timerId, setTimerId] = useState(0);
  const [noData, setNoData] = useState(false);
  const [debounceTimerId, setDebounceTimerId] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const productJson = 
  {
  "name":"Tan Leatherette Weekender Duffle",
  "category":"Fashion",
  "cost":150,
  "rating":4,
  "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
  "_id":"PmInA797xJhMIPti"
  };

  const token = localStorage.getItem("token");
  const [items, setItems] = useState([]);
  const [hasCheckOut, setHasCheckOut] = useState(false);


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async (searchString) => {
    setCircle(1);
    let url = `${config.endpoint}/products`;
 
    if(searchString){
      // console.log("Initial ")
      url = await performSearch(searchString)
      // console.log("Inside If Search url", url)
    }
    // console.log("Outside If Search url", url)
     return axios.get(url)
    .then(response=>
      {
      // console.log("Before product response :: ",response.data);
      setProductData(response.data);
      setNoData(false);
      setCircle(0);
      setCard(1);
      return response.data;
    })
    .catch(er=>{
       console.log("Error :: ",er)
      setNoData(true);
      setProductData([]);
      setCircle(0);
    })
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
   return `${config.endpoint}/products/search?value=${text}`;
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {

    if(timerId !== 0){
      clearInterval(timerId);
    }
   
    const Id = setTimeout(()=>{
      performAPICall(event.target.value)
    },debounceTimeout)

    setTimerId(Id);

  };


  // setTimeout(()=>{
  //   performAPICall();
  //   // console.log("Outside :: ", productResponse);
  // }, 2000)
  // BEFORE DEBOUNCE
  useEffect(() => {
    
    const pageLoad = async ()=>{
      const apiData = await performAPICall();
      if(token){
        const fetchCardData = await fetchCart(token);
        const generateCartData = await generateCartItemsFrom(fetchCardData, apiData);
        // console.log("from useEffect :: ",apiData);
        // console.log("from useEffect :: ",fetchCardData);
         console.log("from useEffect generateCart :: ",generateCartData);
        setItems(generateCartData);
      } 
    }
    // setTimeout(()=>{fetchCart(token)},200);
    
    // debounceSearch()
    pageLoad()
  }, []);

  
  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    // console.log("FetchCart :: ", token); 
    if (!token) return;

    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
    const resCart = await axios.get(`${config.endpoint}/cart`,{
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    console.log("resCart :: ", resCart.data); 
    
    return resCart.data;

    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  const updateCartItems = (cartData, productData) => {
  // console.log("In Products  productData :: ", productData); 
    const cartItems = generateCartItemsFrom(cartData, productData);
    setItems(cartItems);
  }

  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    let bool = false;
    for(let i = 0;i< items.length; i++){
      if(items[i].productId === productId){
        bool = true;
      }
    }
    return bool;
    // if(items){
    //   return items.findindex((item)=> item.productId === productId) !== 1
    // }
  };
  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    // console.log("Inside addToCart :: ",  token, "   ",
    // items, "  ",
    // products, "  ",
    // productId,"  ",
    // qty,)

    if(!token){
      enqueueSnackbar('Login to add an item to the Cart',{variant:'warning'});
      return null;
    }
    // console.log(isItemInCart(items, productId));

  if(options && isItemInCart(items, productId)){
    enqueueSnackbar('Item already in cart. Use the cart sidebar to update quantity or remove item.',{variant:'warning'});
    return null;
 }

  // console.log(productId ,"  ",qty);
  try{
    const addtoCartRes = await axios.post(`${config.endpoint}/cart`,
    {
      "productId" : productId,
      "qty" : qty
    },
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  console.log("addtoCartRes :: ", addtoCartRes);
  const cartRenderData = generateCartItemsFrom(addtoCartRes.data, productData);
  setItems(cartRenderData);
   }catch(e){
    if (e.response && e.response.status === 400) {
      enqueueSnackbar(e.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar(
        "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
        {
          variant: "error",
        }
      );
    }
   }
    
};


return (
    <>
      <Header  hasHiddenAuthButtons={true} >
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        <TextField
        className="search-desktop"
        fullWidth
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        // value={searchString}
        onChange={(e)=>{
          // setSearchString(e.target.value);
          debounceSearch(e, 600);
        }}
      />

      </Header>
      <Grid container>
      <Grid item  md={token ? 9 : 12}>
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e)=>{
          // setSearchString(e.target.value);
          debounceSearch(e, 600);
        }}
      />
       <Grid container mb={2}>
         <Grid item className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
         </Grid>
       </Grid>
      
       {circle === 1 && (
                         <Stack
                         direction="column"
                         justifyContent="center"
                         alignItems="center"
                         spacing={2}
                          minHeight="10vh"
                          mb={40}>
                          <CircularProgress className="circle"/>
                          <h3>Loading Products...</h3>
                          </Stack>)}
        {card === 1 &&  <ProductCard product={productData} items={items} handleAddToCart={addToCart} />  }

        {noData === true && <Box
            display="flex"
            width="100vw"
            height="50vh"
            sx={{"flex-direction":"column" ,  "justify-content":"center" , "align-items":"center" }}>
               <SentimentVeryDissatisfiedIcon />
               <h6>No products found</h6>
            </Box>} 
       </Grid>
    { token && 
        <>
        <Grid item sm={12} md={3} bgcolor="#E9F5E1">
        <Cart 
        hasCheckOut={hasCheckOut}
        products={productData}
        items={items}
        handleQuantity={addToCart}/>
        </Grid>
        </>
		}
    </Grid>
      <Footer />
      </>
  );
};

export default Products;
